<!-- Footer Start -->
<footer class="footer">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-12 mb-0 mb-md-4 pb-0 pb-md-2">
                <a href="#" class="logo-footer">
                    <img src="assets/3r/logo.png" style="width: 200px;height: 50px" alt="">
                </a>
                <!--         <p class="mt-4">Start working with Landrick that can provide everything you need to generate awareness, drive-->
                <!--           traffic, connect.</p>-->
                <ul class="list-unstyled social-icon social mb-0 mt-4">
                    <li class="list-inline-item"><a href="https://www.facebook.com/travels3R" class="rounded">
                        <i-feather name="facebook" class="fea icon-sm fea-social"></i-feather>
                    </a></li>
                    <li class="list-inline-item ml-1"><a href="https://www.instagram.com/3r_travels/" class="rounded">
                        <i-feather name="instagram" class="fea icon-sm fea-social"></i-feather>
                    </a></li>
<!--                    <li class="list-inline-item ml-1"><a href="javascript:void(0)" class="rounded">-->
<!--                        <i-feather name="twitter" class="fea icon-sm fea-social"></i-feather>-->
<!--                    </a></li>-->
<!--                    <li class="list-inline-item ml-1"><a href="javascript:void(0)" class="rounded">-->
<!--                        <i-feather name="linkedin" class="fea icon-sm fea-social"></i-feather>-->
<!--                    </a></li>-->
                </ul>
                <!--end icon-->
            </div>
            <!--end col-->

            <div class="col-lg-4 col-md-6 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0 justify-content-center">
                <h4 class="text-light footer-head text-center">Services</h4>
                <ul class="list-unstyled footer-list mt-4 text-center">
                    <li><a routerLink="/" class="text-foot text-center"> Home</a>
                    <li><a routerLink="/index-packages" class="text-foot text-center"> Packages</a>
                    </li>
                    <li><a routerLink="/index-ticketing" class="text-foot text-center"> Ticketing</a>
                    </li>
                    <li><a routerLink="/index-transport" class="text-foot text-center"> Transport</a></li>
                </ul>
            </div>
            <!--end col-->

            <!--       <div class="col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">-->
            <!--         <h4 class="text-light footer-head">Usefull Links</h4>-->
            <!--         <ul class="list-unstyled footer-list mt-4">-->
            <!--           <li><a routerLink="/page-terms" class="text-foot"><i class="mdi mdi-chevron-right mr-1"></i> Terms of-->
            <!--               Services</a>-->
            <!--           </li>-->
            <!--           <li><a routerLink="/page-privacy" class="text-foot"><i class="mdi mdi-chevron-right mr-1"></i> Privacy-->
            <!--               Policy</a>-->
            <!--           </li>-->
            <!--           <li><a routerLink="/documentation" class="text-foot"><i class="mdi mdi-chevron-right mr-1"></i>-->
            <!--               Documentation</a>-->
            <!--           </li>-->
            <!--           <li><a routerLink="/changelog" class="text-foot"><i class="mdi mdi-chevron-right mr-1"></i> Changelog</a>-->
            <!--           </li>-->
            <!--           <li><a routerLink="/components" class="text-foot"><i class="mdi mdi-chevron-right mr-1"></i> Components</a>-->
            <!--           </li>-->
            <!--         </ul>-->
            <!--       </div>-->
            <!--end col-->

            <div class="col-lg-4 col-md-6 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
<!--                <h4 class="text-light footer-head text-center">Usefull Links</h4>-->
                We have long-standing relationships with all leading domestic air travel operators in Sri Lanka, which
                helps us to be competitive in the market.
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->
</footer>
<!--end footer-->
<!-- <footer class="footer footer-bar">-->
<!--   <div class="container text-center">-->
<!--     <div class="row align-items-center">-->
<!--       <div class="col-sm-6">-->
<!--         <div class="text-sm-left">-->
<!--           <p class="mb-0">© 2020 Landrick. Design with <i class="mdi mdi-heart text-danger"></i> by <a-->
<!--               href="#" target="_blank" class="text-reset">Themesbrand</a>.</p>-->
<!--         </div>-->
<!--       </div>-->
<!--       &lt;!&ndash;end col&ndash;&gt;-->

<!--       <div class="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">-->
<!--         <ul class="list-unstyled text-sm-right mb-0">-->
<!--           <li class="list-inline-item"><a href="javascript:void(0)"><img src="assets/images/payments/american-ex.png"-->
<!--                 class="avatar avatar-ex-sm" title="American Express" alt=""></a></li>-->
<!--           <li class="list-inline-item ml-1"><a href="javascript:void(0)"><img src="assets/images/payments/discover.png"-->
<!--                 class="avatar avatar-ex-sm" title="Discover" alt=""></a></li>-->
<!--           <li class="list-inline-item ml-1"><a href="javascript:void(0)"><img-->
<!--                 src="assets/images/payments/master-card.png" class="avatar avatar-ex-sm" title="Master Card"-->
<!--                 alt=""></a></li>-->
<!--           <li class="list-inline-item ml-1"><a href="javascript:void(0)"><img src="assets/images/payments/paypal.png"-->
<!--                 class="avatar avatar-ex-sm" title="Paypal" alt=""></a></li>-->
<!--           <li class="list-inline-item ml-1"><a href="javascript:void(0)"><img src="assets/images/payments/visa.png"-->
<!--                 class="avatar avatar-ex-sm" title="Visa" alt=""></a></li>-->
<!--         </ul>-->
<!--       </div>-->
<!--       &lt;!&ndash;end col&ndash;&gt;-->
<!--     </div>-->
<!--     &lt;!&ndash;end row&ndash;&gt;-->
<!--   </div>-->
<!--   &lt;!&ndash;end container&ndash;&gt;-->
<!-- </footer>-->
<!--end footer-->
<!-- Footer End -->
